"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MenuList", {
    enumerable: true,
    get: function() {
        return MenuList;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useMenuList = require("./useMenuList");
const _renderMenuList = require("./renderMenuList");
const _useMenuListContextValues = require("./useMenuListContextValues");
const _useMenuListStylesstyles = require("./useMenuListStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const MenuList = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMenuList.useMenuList_unstable)(props, ref);
    const contextValues = (0, _useMenuListContextValues.useMenuListContextValues_unstable)(state);
    (0, _useMenuListStylesstyles.useMenuListStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMenuListStyles_unstable')(state);
    return (0, _renderMenuList.renderMenuList_unstable)(state, contextValues);
});
MenuList.displayName = 'MenuList';
